export const m = {
    // sideBar
    WhatIsFaxchain: '什么是FaxChain',
    Introduction: '简介',
    OnThisPage: '在本页中',
    ConsensusProtocol: '共识',
    KeyFeatures: '主要特征',
    Speed: '速度',
    Scalability: '可扩展性',
    Security: '安全性',
    Flexibility: '灵活性',
    Sustainability: '持续性',
    SmartContractSupport: '智能合约支持',
    PrivateAndPublicBlockchains: '私有和公共区块链',
    DesignedForFinance: '专为金融设计',
    Learn: '学习',
    GettingStarted: '入门',
    TokenAndFees: '代币和费用',
    Wallet: '钱包',
    Transactions: '交易',
    Platform: '平台',
    FaxchainPlatformOverview: 'Faxchain平台概述',
    Subnets: '子网',
    Compliance: '遵从',
    FaxchainBlockchainConsensus: 'Faxchain区块链共识',
    Video: '视频',
    Intuition: '直觉',
    Snowball: '雪球',
    Staking: '质押',
    FaxchainTransactionFee: 'Faxchain交易费',
    FaxchainBridge: 'Faxchain桥(AB)',
    ImportantInformation: '重要信息',
    UserNotes: '用户记录',
    HowToUseLedger: '如何使用Ledger Nano S 或 Nano X',
    BlockchainBasic: '区块链基础',
    FAQ: '常见问题',
    Forum: '论坛',
    Ecosystem: '生态系统',
    Build: '建造',
    ReleaseNotes: '发行说明',
    FaxchainGo: 'Faxchain Go',
    FaxchainNotify: 'Faxchain通知',
    Tutorials: '教程',
    Overview: '概述',
    Subnets: '子网',
    CreateLocalTestNetwork: '创建本地测试网络',
    FujiWorkflow: 'Fuji工作流程',
    FundLocalTestNetwork: '资助本地测试网络',
    NodesAndStaking: '节点和质押',
    SmartContract: '智能合约',
    SmartDigitalAssets: '智能数字资产',
    TutorialsContest: '教程比赛',
    IssuingAPICalls: '发出 API 调用',
    Tools: '工具',
    PublicAPI: '公共API',
    References: '参考',
    CryptographicPrimitives: '密码原语',
    NetworkProtocol: '网络协议',
    SerializationPrimitives: '序列化原语',
    PlatformTransactionFormat: '平台交易格式',
    Whitepapers: '白皮书',
    Audits: '审计',

}